<mat-dialog-content class="modal">
  <p>You have unsaved changes to this report, would you like to save?</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="close()" class="button_small cancel">
    Cancel
  </button>
  <button mat-button (click)="navigate()" class="button_small">
    Continue without saving
  </button>
  <button mat-button (click)="saveandnavigate()" class="button_small">
    Save Changes and Continue
  </button>
</mat-dialog-actions>
